import { Button } from "../ui/button"
import logo from "../../assets/logo2.png"        // logo horizontal
import logoSolo from "../../assets/logoSolo2.png" // tu ícono “g” solo (blanco, sin fondo)
import { motion } from "framer-motion"

const container = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1, y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
}

const stagger = {
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.15 }
  }
}

const item = {
  hidden: { opacity: 0, y: 10, scale: 0.98 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } }
}



export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-[#003226] text-white">
      {/* Radial spotlight + viñeta */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            `radial-gradient(1200px 600px at 50% 30%, rgba(219,197,168,0.10), transparent 65%),
             radial-gradient(900px 500px at 80% 80%, rgba(219,197,168,0.06), transparent 60%),
             radial-gradient(900px 500px at 20% 90%, rgba(255,255,255,0.04), transparent 60%)`
        }}
      />

      {/* Patrón sutil del logo */}
      <div className="absolute inset-0 opacity-[0.035] [mask-image:radial-gradient(ellipse_at_center,black_50%,transparent_90%)]">
        <div
          className="absolute -left-24 -top-24 w-[380px] h-[380px] blur-[1px]"
          style={{ background: `url(${logoSolo}) center/contain no-repeat` }}
          aria-hidden
        />
        <div
          className="absolute right-[-120px] top-10 w-[320px] h-[320px] rotate-12 blur-[1px]"
          style={{ background: `url(${logoSolo}) center/contain no-repeat` }}
          aria-hidden
        />
        <div
          className="absolute left-[10%] bottom-[-80px] w-[460px] h-[460px] -rotate-6 blur-[1px]"
          style={{ background: `url(${logoSolo}) center/contain no-repeat` }}
          aria-hidden
        />
      </div>

      {/* Grid suave (opcional) */}
      <svg
        className="absolute inset-0 opacity-[0.05]"
        aria-hidden
        width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern id="grid" width="36" height="36" patternUnits="userSpaceOnUse">
            <path d="M 36 0 L 0 0 0 36" fill="none" stroke="white" strokeWidth="0.7"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>

      {/* Contenido */}
      <div className="container relative mx-auto px-6 py-24 sm:py-28 lg:py-32">
        <motion.div
          variants={stagger}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center text-center"
        >
          {/* Logo */}
          <motion.img
            variants={item}
            src={logo}
            alt="Gamaan - Servicios Financieros"
            className="w-[280px] sm:w-[360px] md:w-[460px] mb-6 drop-shadow-[0_6px_30px_rgba(0,0,0,0.35)]"
          />

          {/* Badge superior */}
          <motion.div
            variants={item}
            className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur px-3 py-1 text-sm"
          >
            <span className="inline-block h-2 w-2 rounded-full bg-[#DBC5A8]" />
            Más simple, más rápido
          </motion.div>

          {/* Título + copy */}
          <motion.h1
            variants={item}
            className="mt-4 text-[28px] sm:text-[36px] md:text-[44px] font-semibold leading-tight tracking-tight"
          >
            Créditos a tu medida
          </motion.h1>

          <motion.p
            variants={item}
            className="mt-3 max-w-[720px] text-base sm:text-lg text-white/90"
          >
            Solicitá tu préstamo en minutos. 100% online, seguro y transparente.
          </motion.p>

          {/* Chips de tipo de crédito */}
          <motion.ul
            variants={item}
            className="mt-5 flex flex-wrap items-center justify-center gap-2"
          >
            {["Personales", "Hipotecarios", "Prendarios"].map((t) => (
              <li
                key={t}
                className="rounded-full border border-white/15 bg-white/5 px-3 py-1 text-sm text-white/90"
              >
                {t}
              </li>
            ))}
          </motion.ul>

          {/* CTAs */}
          <motion.div
            variants={item}
            className="mt-8 flex flex-col sm:flex-row gap-3"
          >
            <Button
              className="h-11 px-6 bg-[#DBC5A8] text-[#003226] hover:bg-[#cdb89b]"
              size="lg"
              asChild
            >
              <a href="#solicitud" aria-label="Iniciar solicitud de crédito">
                Solicitar Ahora
              </a>
            </Button>

          </motion.div>

          {/* Indicador de scroll */}
          <motion.div
            variants={item}
            className="mt-10 hidden sm:flex flex-col items-center text-white/70"
          >
            <span className="text-xs mb-1">Deslizá para saber más</span>
            <motion.div
              initial={{ y: 0, opacity: 0.7 }}
              animate={{ y: 8, opacity: 1 }}
              transition={{ repeat: Infinity, repeatType: "reverse", duration: 1.2 }}
              className="h-8 w-5 rounded-full border border-white/30 flex items-start justify-center p-1"
            >
              <span className="h-2 w-1 rounded bg-white/80" />
            </motion.div>
          </motion.div>
        </motion.div>
      </div>

      {/* Sombra superior para contraste del navbar (si tenés fija) */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/40 to-transparent" />
    </section>
  )
}
